function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './Switch.styles';
const Switch = /*#__PURE__*/React.forwardRef(({
  ariaLabel,
  id,
  defaultChecked,
  checked,
  onCheckedChange,
  disabled,
  required,
  value,
  label,
  marginLeft
}, ref) => {
  const rootProps = {
    id,
    'aria-label': ariaLabel,
    defaultChecked,
    checked,
    onCheckedChange,
    disabled,
    required,
    value
  };
  const dataDisabled = disabled || undefined;
  return /*#__PURE__*/React.createElement(S.SwitchContainer, {
    "data-disabled": dataDisabled,
    $marginLeft: marginLeft
  }, /*#__PURE__*/React.createElement(S.SwitchRoot, _extends({
    ref: ref
  }, rootProps), /*#__PURE__*/React.createElement(S.SwitchThumb, null)), label ? /*#__PURE__*/React.createElement(S.SwitchLabel, {
    htmlFor: id,
    "data-disabled": dataDisabled
  }, label, " ", required && /*#__PURE__*/React.createElement(S.SwitchRequiredIcon, null)) : null);
});
export { Switch };